/**
 * ManufacturingLocation
 *
 * Location wrapper for the Operations/Manufacturing view.
 * Maps to the "Operations" tab in the original navigation.
 */

import React from 'react';
import { CampusLocation } from '../../types/spatial';
import LocationWrapper from '../spatial/LocationWrapper';
import { OperationsView } from '../tycoon/OperationsView';

export type ManufacturingLocationProps = React.ComponentProps<typeof OperationsView>;

export const ManufacturingLocation: React.FC<ManufacturingLocationProps> = (props) => {
  return (
    <LocationWrapper
      location={CampusLocation.MANUFACTURING}
      title="Manufacturing"
    >
      <OperationsView {...props} />
    </LocationWrapper>
  );
};

export default ManufacturingLocation;
